/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Signal.SignalAnalog.ExtendedConfig <br/>
/// <br/>
/// It contains a list of extended config areas and adds click handler for each area</br>
/// The click handler opens popups with specific configs and reloads the entry after closing the popup.
/// Author: ARF<br />
/// Date: 18.1.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 13.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.SignalAnalogExtendedConfig", $.common.VisualBase, {
   
    //editDialog: null,
    //docWidth: 0,
    //docHeight: 0,
    container: null,
    topocontainer: $("<div>").attr("id", "divEditContainer1"),
    _create: function () {
        var me = this;
        try {
           
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 325;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
          
            //inits the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
         
            me.showMessage("", false);

            me._initEditDialog(0.8, 0.8,"", function () { me._reload() });



           
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
      
        var vcV = new vcVisual();
        try {
          
          
            //add all click handlers 
            me.element.on("click", "#div-rules", function () {
            
                me._initNewContainer();
                vcV.addVisualBaseByName('divEditContainer', 'VISUAL_SIGNAL_ANALOG_RULES', me.container.random, getCurrentTimestamp(), me.container.obj.height(), me.container.obj.width(),
                    JSON.stringify({ "bsaid": me.specific.settings.Bsaid }), '', me.settings.deviceType);
                me.editDialog.dialog("open");
            });
            me.element.on("click", "#div-tags", function () {
                me._initNewContainer();
                vcV.addVisualBaseByName('divEditContainer', 'VISUAL_TAGS_ASSIGNMENT_TAGS2SIGNAL', me.container.random, getCurrentTimestamp(), me.container.obj.height(), me.container.obj.width(),
                    JSON.stringify({ "assid": me.specific.settings.Bsaid}), '', me.settings.deviceType);
                me.editDialog.dialog("open");
            });

            me.element.on("click", "#div-plaus", function () {
                $(".dc-plausibility").html("");
                me._initNewContainer();

                vcV.addVisualBaseByName('divEditContainer', 'VISUAL_DATACENTER_PLAUS', me.container.random, getCurrentTimestamp(), me.container.obj.height(), me.container.obj.width(),
                    JSON.stringify({ "bsaid": me.specific.settings.Bsaid, "loggerid": me.specific.settings.loggerId, "day": getCurrentTimestamp() }), '', me.settings.deviceType);
                me.editDialog.dialog("open");
            });

            me.element.on("click", "#div-auto-check", function () {
                me._initNewContainer();
                me.container.obj.AutoCheckEntries({ invokeType: "addVisualBase", parameter: { bsaid: me.specific.settings.Bsaid} });
                me.editDialog.dialog("open");
            });


            me.element.on("click", "#div-hr", function () {
                me._initNewContainer();
                vcV.addVisualBaseByName('divEditContainer', 'VISUAL_SIGNALANALOG_HR', me.container.random, getCurrentTimestamp(), me.container.obj.height(), me.container.obj.width(),
                    JSON.stringify({ "bsaid": me.specific.settings.Bsaid}), '', me.settings.deviceType);
                me.editDialog.dialog("open");
            });

            me.element.on("click", "#div-datapointnames", function () {
                me._initNewContainer();
                me.container.obj.DataPointNames({ invokeType: "addVisualContent", parameter: { Bsaid: me.specific.settings.Bsaid } });
                me.editDialog.dialog("open");
            });


            me.element.on("click", "#div-del", function () {
                me._initNewContainer();
                vcV.addVisualBaseByName('divEditContainer', 'VISUAL_SIGNAL_ANALOG_DELETION', me.container.random, getCurrentTimestamp(), me.container.obj.height(), me.container.obj.width(),
                    JSON.stringify({ "bsaid": me.specific.settings.Bsaid, "loggerid": me.specific.settings.loggerId, "day": getCurrentTimestamp() }), '', me.settings.deviceType);
                me.editDialog.dialog("open");
            });


            me.element.on("click", "#div-ds-edit", function () {
               
                vcV.showDsEdit2Dialog({ LoggerId: me.specific.settings.loggerId, ShowAnalogEditor:false, bsaid: me.specific.settings.Bsaid, day: moment(getCurrentTimestamp(), 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') });
            });


            me.element.on("click", "#div-topo", function () {
                //the topo is a bit buggy - we have to use the same container all the time
                me.container.obj = me.topocontainer;
                me.container.obj.height(me.editDialog.h - 120);
                me.container.obj.width(me.editDialog.w - 40);
                me.editDialog.html(me.container.obj);
                vcV.addVisualBaseByName('divEditCont', 'VISUAL_SIGNAL_DEPENDENCY',"ainer1", getCurrentTimestamp(), me.container.obj.height(), me.container.obj.width(),'', '', me.settings.deviceType);
                me.editDialog.dialog("open");
            });

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },


    _initNewContainer: function () {
        /// <summary>
        /// This function generates a random sub container and sets height and width. 
        /// </summary>
        var me = this;
        try {

          

            me.container = me.getRandomIDContainerObj("divEditContainer", true);
            me.container.obj.height(me.editDialog.height - 120);
            me.container.obj.width(me.editDialog.width - 40);
            me.editDialog.html(me.container.obj);

        } catch (e) {
            me.writeError('_getnewContainer', e);
        }
    },



    _reload: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {

           
            me.fnd(".box").html(me.getLoadingIcon());


            //don't use me.getData() as it has specific parameters
            window.VisualCoreService.getData(me.options.invoke.vcvid, me.vcgid, me.getCurrentTimestamp(), 0, 0, JSON.stringify({ Bsaid: me.specific.settings.Bsaid, UseInDataCenter: me.specific.settings.UseInDataCenter}), "", me.settings.deviceType, me.settings.langID, "", function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
                }
                me.fnd(".box").html(result);
                return true;
            });

        } catch (e) { me.writeError('reload', e); return false;}
        return true;
    },


    specificInfoHandling: function (bError) {
        var me = this;
        try {
            //if (bError) {
            //    me.fnd(".lst-entries, #div-top-menu, #div-filter-menu").hide();
            //}
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }
    , destroy: function () {
        this.editDialog.dialog("destroy");
        this.editDialog = null;       
        this._super();

    }

});

